import { ProductizedServiceCTAs_productizedService$key } from '#app/__generated__/relay/ProductizedServiceCTAs_productizedService.graphql.js';
import { ServiceInquiryButton } from '../ServiceInquiryButton/ServiceInquiryButton.js';
import { graphql, useFragment } from '@contra/relay';
import { css, styled } from 'styled-components';

type LayoutVariant = 'BLOCK' | 'INLINE';

const ActionButtons = styled.section<{ $layoutVariant: LayoutVariant }>`
  ${({ $layoutVariant }) => css`
    display: flex;
    gap: 8px;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    ${$layoutVariant === 'INLINE' &&
    css`
      flex-direction: row-reverse;
    `}

    & > * {
      max-width: 284px;
    }
  `}
`;

type ProductizedServiceCTAsProps = {
  readonly productizedServiceRef: ProductizedServiceCTAs_productizedService$key;
  readonly variant?: LayoutVariant;
};

export const ProductizedServiceCTAs = ({
  productizedServiceRef,
  variant = 'BLOCK',
}: ProductizedServiceCTAsProps) => {
  const service = useFragment<ProductizedServiceCTAs_productizedService$key>(
    graphql`
      fragment ProductizedServiceCTAs_productizedService on ProductizedService {
        id
        slug
        productizedServiceType
        visitorCanEdit
        userProfile {
          id
        }
        ...ServiceInquiryButton_productizedService
        ...useProductizedServicePreview_productizedService
      }
    `,
    productizedServiceRef,
  );

  return (
    <ActionButtons $layoutVariant={variant}>
      <ServiceInquiryButton
        block={variant === 'BLOCK'}
        buttonVariant="V2Gradient"
        isIconOnly={variant === 'INLINE'}
        minWidth={variant === 'INLINE' ? 0 : undefined}
        productizedServiceRef={service}
        section="sidebar"
      />
    </ActionButtons>
  );
};
